<template>
  <v-container>
    <v-row>
      <v-col>
        <!-- ССЫЛКА НАЗАД -->
        <v-btn
            text
            color="primary"
            @click="$router.push({ name: 'Overview' })"
        >
          <v-icon
              :size="16"
              class="mr-1"
          >
            mdi-arrow-left
          </v-icon>
          {{ $t('common.back') }}
        </v-btn>
      </v-col>
    </v-row>
    <!-- КАРТОЧКИ -->

    <plans-cards v-if="profile && profile.subscription && profile.subscription.plan !== 'trial'" />
    <plans-cards-trial v-else-if="profile && profile.subscription" />

    <!-- ДИАЛОГИ -->
    <prolong-plan-dialog v-if="dialogs.prolongPlan" />
    <update-plan-dialog v-if="dialogs.updatePlan" />
    <switch-plan-dialog v-if="dialogs.switchPlan" />
    <payment-from-trial-dialog v-if="dialogs.paymentFromTrial" />
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import PlansCards from "@/components/plans/PlansCards.vue"
import PlansCardsTrial from "../components/plansTrial/PlansCardsTrial";
import PaymentFromTrialDialog from "@/components/plans/dialogs/PaymentFromTrialDialog";
import UpdatePlanDialog from "@/components/plans/dialogs/UpdatePlanDialog.vue";
import SwitchPlanDialog from "@/components/plans/dialogs/SwitchPlanDialog.vue";
import ProlongPlanDialog from '@/components/plans/dialogs/ProlongPlanDialog.vue'

export default {
  name: 'Plans',

  components: {
    ProlongPlanDialog,
    PlansCards,
    PlansCardsTrial,
    PaymentFromTrialDialog,
    UpdatePlanDialog,
    SwitchPlanDialog
  },

  computed: {
    ...mapGetters({
      dialogs: 'plans/dialogs',
      profile: 'main/profile',
    }),
  }

};
</script>
